<script>
    import { getContext } from 'svelte'
    import { slide }      from 'svelte/transition'
    import * as api       from '../../shared/api.js'
    import Affected       from '../../shared/Affected.svelte'
    import Duration       from '../../shared/Duration.svelte'
    
    export let domain    = null
    export let place     = null
    export let field     = {}
    export let mode      = null
    export let active    = null

    let scopes   = field.scopes.filter(s => s !== "FIXED")
    let fixed    = field.scopes.find(s => s === "FIXED")
    let working  = false
    let error    = null
    let affected = [] //activities affected by this field if removed

    const ctx = getContext('inventory')

    function forceRemove() {
        remove(true)
        affected  = []
    }

    function cancelRemove() {
        affected  = []
    }

    function tryToRemove() {
        return remove(false)
    }

    function remove(force) {
        working = true
        error   = null
        return api
            .post(`/inventory/domain/${domain.id}/delete/field`, { id: field.id, place: field.place, force: !!force })
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                ctx.set(json)
                cancel()
            })
            .catch(res => {
                working = false
                if(res.status == 406) {
                    res.json().then(json => affected = json)
                } else {
                    error = 'erro removendo campo'
                }
                setTimeout(() => { error = null }, 5000)
            })
    }

    function add() {

        field.duration = field.duration ? parseInt(field.duration) : null

        let data = {
            ...field, scopes: fixed ? ["FIXED"] : scopes, place: place.id
        }
        data = field.id === 0 ? data : { data, id: field.id }
        const method = field.id === 0 ? 'add' : 'update'
        working = true
        error   = null
        return api
            .post(`/inventory/domain/${domain.id}/${method}/field`, data)
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                ctx.set(json)
                cancel()
            })
            .catch(err => {
                console.log(err)
                working = false
                error   = field.id === 0 ? 'erro criando campo' : 'erro atualizando campos'
                setTimeout(() => {
                    error = null
                }, 3000)
            })
    }

    function cancel() {
        error  = null
        mode   = null
        active = null
        field  = {} // { id: 0, key: false, required: false, scopes: [], definition: null, name: null }
    }

    function clear(it) {
        return e => {
            const checked = e.target.checked
            if(it === 'fixed') {
                if(!checked && scopes.length === 0) {
                    fixed = true
                } else {
                    fixed = false
                }
            } else {
                if(!checked) {
                    scopes = ['SAR', 'DDR', 'RET']
                } else {
                    scopes = []
                }
            }
        }
    }

    function unitSelected(option) {
        field.unit = option.value
    }

    $: disabled = working || error
    $: noDuration = disabled || !field.duration
</script>
<div class="ui tertiary grey basic segment" class:loading={working}>
    <!-- <div>id {field.id}</div> -->
    <!-- <div>scopes: {scopes}</div>
    <div>fixed: {fixed}</div> -->
    <!-- {JSON.stringify(field)} -->
    {#if error}
        <div transition:slide class="ui top attached red label">{error}</div>    
    {/if}
    <div class="grid">
        <div>
            <div>
                <h3 class="ui header">Requerimentos</h3>
                <div class="toggles">
                    <div class="ui toggle checkbox" class:disabled>
                        <input type="checkbox" bind:checked={field.key}>
                        <label>chave de busca</label>
                    </div>
                    <div class="ui toggle checkbox" class:disabled>
                        <input type="checkbox" bind:checked={field.required}>
                        <label>obrigatório</label>
                    </div>
                    <div class="ui toggle checkbox" class:disabled>
                        <input type="checkbox" bind:checked={field.sensitive}>
                        <label>dado sensível</label>
                    </div>
                    <div class="ui toggle checkbox" class:disabled>
                        <input type="checkbox" bind:checked={field.underage}>
                        <label>menor de idade</label>
                    </div>
                </div>
            </div>
            <div>
                <h3 class="ui header">Escopo</h3>
            </div>
            <div class="toggles">
                <div class="ui toggle checkbox" class:disabled>
                    <input type="checkbox" value="SAR" bind:group={scopes} on:change={clear('fixed')}>
                    <label>Acesso</label>
                </div>
                <div class="ui toggle checkbox" class:disabled>
                    <input type="checkbox" value="DDR" bind:group={scopes} on:change={clear('fixed')}>
                    <label>Remoção</label>
                </div>
                <div class="ui toggle checkbox" class:disabled>
                    <input type="checkbox" value="RET" bind:group={scopes} on:change={clear('fixed')}>
                    <label>Retificação</label>
                </div>
                <div class="ui toggle checkbox" class:disabled>
                    <input type="checkbox" bind:checked={fixed} on:change={clear('scopes')}>
                    <label>Fixo</label>
                </div>
            </div>
        </div>
        <div>
            <h3 class="ui header">Informações</h3>
            <form class="ui form">
                <div class="field">
                    <label>Nome</label>
                    <div class="ui right icon input" class:disabled>
                        <input bind:value={ field.definition } />
                        <i class="green check icon"></i>
                    </div>
                </div>
                <div class="field">
                    <label>Nome no Relatório</label>
                    <div class="ui right icon input" class:disabled>
                        <input bind:value={ field.name } />
                        <i class="green check icon"></i>
                    </div>
                </div>
                <div class="field">
                    <label>Descrição</label>
                    <div class="ui right icon input" class:disabled>
                        <input bind:value={ field.description } />
                        <i class="green check icon"></i>
                    </div>
                </div>
            </form>
        </div>
        <div>
            <h3 class="ui header">Atributos</h3>
            <form class="ui form">
                <!-- <div class="field">
                    <label>Formato</label>
                    <div class="ui right icon input" class:disabled>
                        <select class="ui dropdown" bind:value={field.kind}>
                            <option value="">--</option>
                            <option value="TEXT">texto</option>
                            <option value="IMAGE">imagem</option>
                            <option value="PDF">pdf</option>
                        </select>
                    </div>
                </div> -->
                <div class="field">
                    <label>Natureza</label>
                    <div class="ui right icon input" class:disabled>
                        <select class="ui dropdown" bind:value={field.nature}>
                            <option value="">--</option>
                            <option value="ID">identificador</option>
                            <option value="NAME">nome</option>
                            <option value="DOCUMENT">documento</option>
                            <option value="ADDRESS">endereço</option>
                            <option value="PHONE">telefone</option>
                            <option value="EMAIL">email</option>
                        </select>
                    </div>
                </div>
                <div class="field">
                    <label>Armazenamento</label>
                    <div class="ui right icon input" class:disabled>
                        <select class="ui dropdown" bind:value={field.storage}>
                            <option value="PLAIN"    >simples</option>
                            <option value="TRUNCATED">truncado</option>
                            <option value="HASHED"   >hash</option>
                            <option value="ENCRYPTED">criptografado</option>
                        </select>
                    </div>
                </div>
                <div class="two fields">
                    <Duration {disabled} {unitSelected} unit={field.unit} bind:duration={field.duration}/>
                    <!-- <div class="ui right icon input" class:disabled>
                        <select class="ui dropdown" bind:value={field.retention}>
                            <option value="UNLIMITED">ilimitado</option>
                        </select>
                    </div> -->
                </div>
                <div class="field" class:disabled>
                    <label>Observações (Período)</label>
                    <textarea bind:value={ field.periodRemarks } rows="3"></textarea>
                </div>
            </form>
        </div>
        <div class="buttons">
            <button class="ui button" 
                    class:disabled={disabled || field.id === 0} 
                    on:click|preventDefault={tryToRemove}>
                Remover
            </button>
            <button class="ui button" class:disabled on:click|preventDefault={add}>
                {#if field.id > 0}
                    Atualizar
                {:else}
                    Adicionar
                {/if}
            </button>
            <button class="ui button" 
                    class:disabled 
                    on:click|preventDefault={cancel}>
                Cancelar
            </button>
        </div>
    </div>
</div>

<Affected activities={affected} what="campo" cancel={cancelRemove} confirm={forceRemove}></Affected>

<style>

    .grid {
        padding: 3em;
        display: grid;
        grid-template-columns: 2fr 4fr 3fr 2fr;
        grid-gap: 3em;
    }

    .toggles {
        display: flex;
        flex-direction: column;
        margin: 1em;
    }

    .toggles .checkbox {
        margin: 1em 0;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .buttons button {
        margin: 1em 2em;

    }

    .inverted .header,
    .inverted label,
    .inverted .ui.toggle.checkbox label {
        color: #fff !important;
    }
</style>
